/* global mcgdVars */

import Awesomplete from 'awesomplete';
import throttle from 'lodash/throttle';

/**
 * Add autocompletion to the location search input
 */
const init = () => {
	const input = document.querySelector('input[name="location"]');

	if (!input) {
		return;
	}

	const awesomplete = new Awesomplete(input, { tabSelect: true, minChars: 3 });

	let list = [];
	const cachedList = {};

	/**
	 * Ajax a new request for posts
	 */
	function ajaxResults(e) {
		const code = e.keyCode || e.which;

		// Wait until we have 3 chars before firing a request
		if (input.value.length < 3) {
			return;
		}

		// check to see if we have results for the current input cached
		if (input.value in cachedList) {
			awesomplete.list = cachedList[input.value];
			return;
		}

		// Don't fire for keys that aren't letters
		if (
			code === 37 ||
			code === 38 ||
			code === 39 ||
			code === 40 ||
			code === 27 ||
			code === 13 ||
			code === 16
		) {
			return;
		}

		const endpointURL = mcgdVars.endpoints.locationAutocomplete + input.value;

		const ajax = new XMLHttpRequest();
		ajax.open('GET', endpointURL, true);

		// Process the returned results
		ajax.onload = () => {
			if (ajax.status === 200) {
				list = JSON.parse(ajax.responseText).map((item) => {
					return item[0];
				});

				cachedList[input.value] = list;
				awesomplete.list = list;
			} else {
				list = [];
			}
		};

		ajax.send();
	}

	input.addEventListener('keyup', throttle(ajaxResults, 1000));
};

init();
